module.exports = __webpack_public_path__ + "static/media/iv_thumbs_up_active.9e3f135e.svg";